import * as get from 'lodash/get';

import { OutputResult } from '../models/output-result.model';
import { OutputSelector } from './output-selector.interface';

export class SelectFirst implements OutputSelector {
	public select(outputs: OutputResult[]): string {
		if (outputs instanceof Array && get(outputs, 'length')) {
			return outputs[0].output;
		}
		throw new Error('Output is not in the right format');
	}
}
